import { useState } from "react";
import { faMinus, faPlus, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { formatImageUrl } from "../../_helpers/route-image";
import { useProduct } from "../../services/products/product.context";


export const CartItem = ({ itemData, removeFromCart, addOne, reduceOne }) => {

     const discount  = itemData?.pricing?.discount;
     const cost = itemData?.pricing?.original_cost;

     const { addToCart } = useProduct(); 

    const [quantity, setQuantity] = useState(itemData?.quantity || 1);


    const toggleCartAdd = (data) => {
        addToCart(data, quantity);
    }
    

    const increment = () => {
        setQuantity((v) => v + 1);
        addOne(itemData?._id, quantity + 1)
    }
    const decrement = () => {
        if (quantity === 1) return;
        setQuantity((v) => v - 1);
        reduceOne(itemData?._id, quantity - 1);
    }
    return (
        <div className="cart-item-container">
            <div className="cart-object">
                <div className="remove-container">
                    <button 
                        className="remove-cart-button"
                        onClick={() => removeFromCart(itemData?._id,quantity)}
                    >
                        <FontAwesomeIcon icon={faTrashAlt} />
                    </button>
                </div>
                <img src={formatImageUrl(itemData?.images[0])} alt="" className="cart-item-img" />
                <div className="cart-item-infos">
                    <div className="cart-item-name">{itemData?.designation}</div>
                    <div className="cart-item-prices">
                        {discount > 0 && (
                            <s style={{color: "#888888"}}>
                                <div className="cart-item-old-price">
                                    FCFA {(cost).toLocaleString()}
                                </div>
                            </s>
                        )}
                        <div className="cart-item-cost">
                            FCFA {(cost - discount * cost).toLocaleString() }
                        </div>
                    </div>
                </div>
            </div>
            <div className="cart-object-actions">
                <div className="quantity-area">
                    <button className="q-button" onClick={decrement}>
                        <FontAwesomeIcon icon={faMinus} />
                    </button>
                    <input
                        type="number"
                        onChange={(e) => setQuantity(e.target.value)}
                        value={quantity}
                        className="q-input"
                    />
                    <button className="q-button" onClick={increment}>
                        <FontAwesomeIcon icon={faPlus} />
                    </button>
                </div>
                <div className="item-sub-total">
                    <span className="sub-caption">Sub-Total</span>
                    <span className="sub-amount">FCFA {((cost - discount * cost) * quantity).toLocaleString() }</span>
                </div>
            </div>
        </div>
    )
}